import { render, staticRenderFns } from "./SearchResultsPieChart.vue?vue&type=template&id=7a52f57a&scoped=true&"
import script from "./SearchResultsPieChart.vue?vue&type=script&lang=js&"
export * from "./SearchResultsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsPieChart.vue?vue&type=style&index=0&id=7a52f57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a52f57a",
  null
  
)

export default component.exports